import { define, html, Component, store } from "hybrids";
import Broadcast from "~/stores/Broadcast";

export interface VBroadcastStats {
  broadcast: Broadcast;
}

const numberFormat = new Intl.NumberFormat();

export default define<VBroadcastStats>({
  tag: "v-broadcast-stats",
  broadcast: undefined,
  render: ({ broadcast }) => html`
    <v-ui-text color="text-secondary">
      <v-ui-icon name="usertwo" color="text-secondary" size="small"></v-ui-icon>
      ${store.ready(broadcast) &&
      !!broadcast.connected.length &&
      `${numberFormat.format(broadcast.connected.length)} online`}
    </v-ui-text>
    <v-ui-text color="text-secondary">
      ${store.ready(broadcast) && numberFormat.format(broadcast.likes)}
      <v-ui-icon
        name="applause"
        color="text-secondary"
        size="small"
      ></v-ui-icon>
    </v-ui-text>
  `.css`
    :host {
      display: flex;
      justify-content: space-between;
    }

    v-ui-text {
      display: grid;
      grid-auto-flow: column;
      grid-gap: 4px;
      align-items: center;
    }
  `,
});
